export const TIMEZONES = [
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST, UTC+5:30)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (GST, UTC+4)' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore (SGT, UTC+8)' },
  { value: 'Europe/London', label: 'Europe/London (UK time)' },
  { value: 'America/New_York', label: 'America/New_York (US Eastern)' },
  { value: 'UTC', label: 'UTC' },
];

export const LANGUAGES = [
  { value: 'en-IN', label: 'English (India)' },
  { value: 'en-US', label: 'English (US)' },
  { value: 'en-GB', label: 'English (UK)' },
];

export const DATE_FORMATS = ['d MMM yyyy', 'dd/MM/yyyy', 'MM/dd/yyyy'] as const;

export const WEEK_STARTS = [
  { value: 'monday', label: 'Monday' },
  { value: 'sunday', label: 'Sunday' },
  { value: 'saturday', label: 'Saturday' },
] as const;

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** The three date styles the Settings picker offers, rendered for `date` ("22 Oct 2026"). */
export function formatDatePattern(date: Date, pattern: string): string {
  const d = date.getDate();
  const m = date.getMonth();
  const y = date.getFullYear();
  const two = (n: number) => String(n).padStart(2, '0');
  if (pattern === 'dd/MM/yyyy') return `${two(d)}/${two(m + 1)}/${y}`;
  if (pattern === 'MM/dd/yyyy') return `${two(m + 1)}/${two(d)}/${y}`;
  return `${d} ${MONTHS[m]} ${y}`;
}

export { staffProfileFormSchema, type StaffProfileForm } from '@mybusinessmate/schema';
